// RestoreNotice — one dismissable banner shown when the page loaded from a
// shared `?s=` link (#244).
//
// Replaces the old inline simulate-bar hint + the Simulate-button highlight +
// the provenance-line drift notice with a single, dismissable info banner at
// the top of the results column. The reform auto-runs on restore (#297), so the
// banner just confirms what loaded and, when the link was minted on a different
// build, carries the reproducibility drift line. Closing it is sticky for the load.
//
// State comes from the boot-time decode (state/share_restore): isRestoreActive
// is set once before islands mount, so a plain read on first render is correct.

import { useState } from "react";
import { appVersion, engineVersion } from "../lib/app_meta";
import { getRestoreFingerprint, isRestoreActive } from "../state/share_restore";
import { isVersionMismatch } from "../state/share_notice";

export function RestoreNotice(): JSX.Element | null {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || !isRestoreActive()) return null;

  const fp = getRestoreFingerprint();
  const drift = isVersionMismatch(fp, appVersion(), engineVersion());

  return (
    <div className="beamm-restore-notice" role="status" data-testid="restore-notice">
      <p className="beamm-restore-notice__text">
        <strong>Shared reform loaded.</strong> Showing its results below.
        {drift && fp ? (
          <span className="beamm-restore-notice__drift">
            {" "}
            This link was created with app {fp.app} · engine {fp.eng}; you’re on
            app {appVersion()} · engine {engineVersion()}, so the results may
            differ.
          </span>
        ) : null}
      </p>
      <button
        type="button"
        className="beamm-restore-notice__close"
        data-testid="restore-notice-close"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      >
        ×
      </button>
    </div>
  );
}
